export default __webpack_public_path__ + "static/media/paymentFailed.9e381390.png";